import { Injectable } from '@angular/core';
import {ApiService} from "../api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {Pagination} from "../../models/pagination";
import {map} from "rxjs/operators";
import {plainToClass} from "class-transformer";
import {OfferPermanentOption} from "../../models/offer/offer-permanent-option";

@Injectable({
  providedIn: 'root'
})
export class OfferPermanentOptionService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {
    }

    public getItemsAPI(societyId: number, params?: string[]): Observable<OfferPermanentOption[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${societyId}/offerPermanentOptions`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<OfferPermanentOption[]>(url, {
            headers: headers
        }).pipe(
            map((items: object[]): OfferPermanentOption[] => {

                return items.map((item: object): OfferPermanentOption => {

                    return plainToClass(OfferPermanentOption, item);
                });
            })
        );
    }

    public getPaginationItemsAPI(societyId: number, params?: string[]): Observable<Pagination<OfferPermanentOption>> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${societyId}/offerPermanentOptions`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<OfferPermanentOption>>(url, {
            headers: headers
        }).pipe(
            map((pagination: Pagination<object>): Pagination<OfferPermanentOption> => {

                return Object.assign(pagination, {
                    items: pagination.items.map((item: object): OfferPermanentOption => {

                        return plainToClass(OfferPermanentOption, item);
                    })
                });
            })
        );
    }

    public getOfferItemsAPI(offerId: number, locale: string, params?: string[]): Observable<OfferPermanentOption[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/offers/${offerId}/${locale}/permanentOptions`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<OfferPermanentOption[]>(url, {
            headers: headers
        }).pipe(
            map((items: object[]): OfferPermanentOption[] => {

                return items.map((item: object): OfferPermanentOption => {

                    return plainToClass(OfferPermanentOption, item);
                });
            })
        );
    }

    public getItemAPI(id: number): Observable<OfferPermanentOption> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.get<OfferPermanentOption>(`${this._apiService.getApiUrl(false, true)}/offerPermanentOptions/${id}`, {
            headers: headers
        }).pipe(
            map((item: object): OfferPermanentOption => {

                return plainToClass(OfferPermanentOption, item);
            })
        );
    }

    public createItemAPI(societyId: number, data: object): Observable<OfferPermanentOption> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<OfferPermanentOption>(`${this._apiService.getApiUrl(false, true)}/societies/${societyId}/offerPermanentOptions`, data, {
            headers: headers
        }).pipe(
            map((item: object): OfferPermanentOption => {

                return plainToClass(OfferPermanentOption, item);
            })
        );
    }

    public updateItemAPI(id: number, data: object): Observable<OfferPermanentOption> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.patch<OfferPermanentOption>(`${this._apiService.getApiUrl(false, true)}/offerPermanentOptions/${id}`, data,{
            headers: headers
        }).pipe(
            map((item: object): OfferPermanentOption => {

                return plainToClass(OfferPermanentOption, item);
            })
        );
    }

    public deleteItemAPI(id: number): Observable<void> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.delete<void>(`${this._apiService.getApiUrl(false, true)}/offerPermanentOptions/${id}`,{
            headers: headers
        });
    }
}
